import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Tooltip, Select } from 'antd';
import { InfoCircleOutlined, CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { FORM_NOT_EMPTY_RULE } from '../../../../../utils';
import { PaddedButton } from '../styles';
import { ERROR_MESSAGES, LAYOUT_STYLES, TAIL_STYLES } from '../constants';

const IpForm = ({ onSubmit, onBack }) => {
  const [ipv4, setIpv4] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log('Fetched IPv4:', data.ip);
        setIpv4(data.ip);
      })
      .catch((err) => {
        console.error('Error fetching IPv4:', err);
        setIpv4(ERROR_MESSAGES.UNABLE_TO_FETCH_IPV4);
      });
  }, []);

  const handleCopyIp = () => {
    if (ipv4 && ipv4 !== ERROR_MESSAGES.UNABLE_TO_FETCH_IPV4) {
      navigator.clipboard.writeText(ipv4);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }
  };

  return (
    <>
      <div>
        <InfoCircleOutlined style={{ marginRight: 4 }} />
        <span>{ERROR_MESSAGES.IP_TRACING_US_ONLY}</span>
      </div>
      {ipv4 && (
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
          <b>Your IP Address: </b> {ipv4}
          {copied ? (
            <CheckOutlined style={{ marginLeft: 8, fontSize: 18, transition: 'all 0.2s' }} />
          ) : (
            <CopyOutlined
              style={{
                marginLeft: 8,
                cursor: ipv4 !== ERROR_MESSAGES.UNABLE_TO_FETCH_IPV4 ? 'pointer' : 'not-allowed',
                fontSize: 18,
                transition: 'all 0.2s',
              }}
              onClick={handleCopyIp}
              title="Copy IP address"
              aria-label="Copy IP address"
            />
          )}
        </div>
      )}
      <Form {...LAYOUT_STYLES} onFinish={onSubmit}>
        <Form.Item
          label="IP Address"
          name="ip"
          rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_IP }, FORM_NOT_EMPTY_RULE]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Channel" name="channel" rules={[]}>
          <Select placeholder="Select a channel">
            <Select.Option value="acc">acc</Select.Option>
            <Select.Option value="accextra">accextra</Select.Option>
            <Select.Option value="deportes">deportes</Select.Option>
            <Select.Option value="espn">espn</Select.Option>
            <Select.Option value="espn2">espn2</Select.Option>
            <Select.Option value="espn3">espn3</Select.Option>
            <Select.Option value="espnews">espnews</Select.Option>
            <Select.Option value="espnu">espnu</Select.Option>
            <Select.Option value="sec">sec</Select.Option>
            <Select.Option value="secplus">secplus</Select.Option>
            <Select.Option value="espnplus">espnplus</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Distribution Partner"
          name="distro-partner"
          rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_DISTRIBUTION_PARTNER }, FORM_NOT_EMPTY_RULE]}
        >
          <Select placeholder="Select a distribution partner">
            <Select.Option value="ATT_UVERSE">AT&T U-Verse</Select.Option>
            <Select.Option value="CHARTER">Charter</Select.Option>
            <Select.Option value="COMCAST">Comcast</Select.Option>
            <Select.Option value="COX">Cox</Select.Option>
            <Select.Option value="DIRECTV_STREAM">DirecTV Stream</Select.Option>
            <Select.Option value="DIRECTV_EVERYWHERE">DirecTV TVE</Select.Option>
            <Select.Option value="DISH_ANYWHERE">Dish DANY</Select.Option>
            <Select.Option value="FUBO_TV">Fubo</Select.Option>
            <Select.Option value="HULU_MPVD">Hulu</Select.Option>
            <Select.Option value="MLB_TV">MLB.TV</Select.Option>
            <Select.Option value="DISH_SLING">Sling TV</Select.Option>
            <Select.Option value="VERIZON_FIOS">Verizon Fios</Select.Option>
            <Select.Option value="YOUTUBE_TV">YouTube TV</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={
            <span>
              Nickname&nbsp;
              <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
          }
          name="nickname"
          rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_NICKNAME }, FORM_NOT_EMPTY_RULE]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...TAIL_STYLES}>
          <Button onClick={onBack}>Back</Button>
          <PaddedButton type="primary" htmlType="submit">
            Submit
          </PaddedButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default IpForm;
